import {forwardRef} from "react";
import {useTheme} from './Context'
import {SpacialFn, VisualFn} from './Style'

const WithTheme = forwardRef<
    any,
    {
        identifier: string,
        Component: any
    }
>(({
    identifier,
    Component,
    ...props
}, ref) => {
    const [
        styleProps,
        customProps
    ] = useTheme(identifier, props)

    const margin = SpacialFn.normalizeMargin(
        styleProps.margin,
        styleProps.theme
    );

    const padding = SpacialFn.normalizePadding(
        styleProps.padding,
        styleProps.theme
    );

    const border = VisualFn.normalizeBorder(
        styleProps.border,
        styleProps.theme
    );

    return <Component
        ref={ref}

        {...styleProps}
        margin={margin}
        padding={padding}
        border={border}

        {...customProps}
    />
})

export {
    WithTheme
}
